/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsListForPackVo } from './GoodsListForPackVo';
import {
    GoodsListForPackVoFromJSON,
    GoodsListForPackVoFromJSONTyped,
    GoodsListForPackVoToJSON,
    GoodsListForPackVoToJSONTyped,
} from './GoodsListForPackVo';

/**
 * 
 * @export
 * @interface ResponseGoodsListForPackVo
 */
export interface ResponseGoodsListForPackVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGoodsListForPackVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGoodsListForPackVo
     */
    message?: string;
    /**
     * 
     * @type {GoodsListForPackVo}
     * @memberof ResponseGoodsListForPackVo
     */
    data?: GoodsListForPackVo;
}

/**
 * Check if a given object implements the ResponseGoodsListForPackVo interface.
 */
export function instanceOfResponseGoodsListForPackVo(value: object): value is ResponseGoodsListForPackVo {
    return true;
}

export function ResponseGoodsListForPackVoFromJSON(json: any): ResponseGoodsListForPackVo {
    return ResponseGoodsListForPackVoFromJSONTyped(json, false);
}

export function ResponseGoodsListForPackVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGoodsListForPackVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GoodsListForPackVoFromJSON(json['data']),
    };
}

export function ResponseGoodsListForPackVoToJSON(json: any): ResponseGoodsListForPackVo {
    return ResponseGoodsListForPackVoToJSONTyped(json, false);
}

export function ResponseGoodsListForPackVoToJSONTyped(value?: ResponseGoodsListForPackVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GoodsListForPackVoToJSON(value['data']),
    };
}

